export default __webpack_public_path__ + "static/media/goal.d4d12f10.png";